import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { usersAPI } from '../../services/api';

export const fetchUsers = createAsyncThunk('users/fetchAll', async (params, { rejectWithValue }) => {
  try { const res = await usersAPI.list(params); return res.data; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed'); }
});

export const createUser = createAsyncThunk('users/create', async (data, { rejectWithValue }) => {
  try { const res = await usersAPI.create(data); return res.data; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed to create user'); }
});

export const updateUser = createAsyncThunk('users/update', async ({ id, data }, { rejectWithValue }) => {
  try { const res = await usersAPI.update(id, data); return res.data; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed to update user'); }
});

// Soft delete — deactivates the account (isActive=false), record preserved.
export const deactivateUser = createAsyncThunk('users/deactivate', async (id, { rejectWithValue }) => {
  try { await usersAPI.delete(id); return id; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed to deactivate user'); }
});

// Hard delete — permanently removes the user record.
export const deleteUser = createAsyncThunk('users/delete', async (id, { rejectWithValue }) => {
  try { await usersAPI.deletePermanent(id); return id; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed to delete user'); }
});

const usersSlice = createSlice({
  name: 'users',
  initialState: { items: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.users;
      })
      .addCase(fetchUsers.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(createUser.fulfilled, (state, action) => {
        if (action.payload.user) state.items.push(action.payload.user);
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        if (action.payload.user) {
          const idx = state.items.findIndex(u => u._id === action.payload.user._id);
          if (idx !== -1) state.items[idx] = action.payload.user;
        }
      })
      .addCase(deactivateUser.fulfilled, (state, action) => {
        const idx = state.items.findIndex(u => u._id === action.payload);
        if (idx !== -1) state.items[idx].isActive = false;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.items = state.items.filter(u => u._id !== action.payload);
      });
  },
});

export default usersSlice.reducer;
